import script from "./faqPage.vue?vue&type=script&setup=true&lang=js"
export * from "./faqPage.vue?vue&type=script&setup=true&lang=js"

import "./faqPage.vue?vue&type=style&index=0&id=6ba6a4ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba6a4ba"]])

export default __exports__